<template>
    <div>
        <form >
            <strong style="display: block;">Informations de la réservation</strong>

            <div style="display: block; width: 100%;" >
                <div style="text-align: left; width: 32%; display: inline-block; padding: 3px">
                    <small style="display: block">Heure de début</small>
                    <strong>{{ moment(slotActivity.start.date).format('H:mm') }}</strong>
                </div>

                <div class="col-3" style="text-align: left; width: 32%; display: inline-block; padding: 3px">
                    <small >Durée</small>
                    <select class="form-control" v-model="durationSelected" required>
                        <option :value="duration" v-for="duration in durations">{{ duration }} minutes</option>
                    </select>
                </div>

                <div class="col-3" style="text-align: center; width: 32%; display: inline-block; padding: 3px">
                    <small class="text-center" style="display: block">Tarif</small>
                    <strong>{{ priceActivity() }} €</strong>
                </div>
            </div>

            <div v-for="item in items" style="text-align: left; width: 32%; display: inline-block; padding: 3px">

                <div v-if="item.type == 'booker'">

                    <div v-if="item.modele == 'input-text'" >
                        <small>{{ item.label }}</small>
                        <input class="form-control" type="text" :id="'input-'+item.id" v-on:change="updateValue(item.id)" />
                    </div>

                    <div v-if="item.modele == 'input-number'" >
                        <small>{{ item.label }}</small>
                        <input v-if="item.ref == 'count_attenders'" readonly class="form-control" type="number" :id="'input-'+item.id" :value="getTotalPlayer()" min="1" />
                        <input v-else class="form-control" type="number" :id="'input-'+item.id" v-on:change="updateValue(item.id)" value="0" />
                    </div>

                    <div v-if="item.modele == 'input-tel'" >
                        <small>{{ item.label }}</small>
                        <input class="form-control" type="tel" :id="'input-'+item.id" v-on:change="updateValue(item.id)" />
                    </div>

                    <div v-if="item.modele == 'input-email'" >
                        <small>{{ item.label }}</small>
                        <input class="form-control" type="email" :id="'input-'+item.id" v-on:change="updateValue(item.id)" />
                    </div>

                </div>
            </div>
            <div>
                <button class="btn btn-outline-primary" type="button" v-on:click="addAttenders(1)">Ajouter 1 participant</button>
                <button class="btn btn-primary" type="button" v-on:click="addAttenders(5)"><i class="fa fa-plus"></i>5</button>
                <button class="btn btn-primary" type="button" v-on:click="addAttenders(10)"><i class="fa fa-plus"></i>10</button>
                <button class="btn btn-primary" type="button" v-on:click="addAttenders(15)"><i class="fa fa-plus"></i>15</button>
                <button v-if="getNbAttenders() > 0" type="button" class="btn btn-danger" v-on:click="removeAttender(0)"><i class="fa fa-trash"></i></button>
                <strong v-if="getNbAttenders() > 0" style="margin-top: 20px; display: block">Information(s) participant(s)</strong>
            </div>
            <div v-for="(attender, index) in attenders" v-bind:key="index" :id="'attender-' + index">
                <div style="width: 100%; display: inline-block;">
                    <div v-for="item in items" style="text-align: left; width: 32%; display: inline-block; padding: 3px">
                        <div v-if="item.type == 'attender'">
                            <div v-if="item.modele == 'input-text'">
                                <small>{{ item.label }}</small>
                                <input class="form-control" type="text" :id="'input-'+item.id+'-'+index" v-on:change="updateValueAttender(item.id, index)" />
                            </div>
                            <div v-if="item.modele == 'input-number'">
                                <small>{{ item.label }}</small>
                                <input class="form-control" type="number" :id="'input-'+item.id+'-'+index" v-on:change="updateValueAttender(item.id, index)" />
                            </div>
                            <div v-if="item.modele == 'input-tel'">
                                <small>{{ item.label }}</small>
                                <input class="form-control" type="tel" :id="'input-'+item.id+'-'+index" v-on:change="updateValueAttender(item.id, index)" />
                            </div>
                            <div v-if="item.modele == 'input-email'">
                                <small>{{ item.label }}</small>
                                <input class="form-control" type="email" :id="'input-'+item.id+'-'+index" v-on:change="updateValueAttender(item.id, index)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div style="position: relative">
                <button class="btn btn-success" style="position: static; margin-top: 20px; width: 100%" type="button" v-on:click="valideForm()">valider ma réservation</button>
            </div>
            <div style="position: relative">
                <button class="btn btn-warning" v-on:click="handleCanceled()" style="position: static; margin-top: 20px; width: 100%" type="button" >Annuler</button>
            </div>
        </form>
    </div>
</template>
<script>

    import moment from 'moment';
    import bookingService from '../services/BookingService.js';

    export default {
        name: "close-button",
        props: {
            date: String,
            items: Array,
            slotActivity: Object,
            playgroundId: Number,
        },
        data() {
            return {
                attendersActivity: [],
                inputData: [],
                nbAttenders: 1,
                attenders: [],
                durations: [],
                durationSelected: null,
            }
        },
        mounted() {
            let timeStart = moment(this.date).format('Y-MM-D') + " "+ moment(this.slotActivity.start.date).format('H:mm');
            bookingService.getDuration(this.slotActivity.playgroundId, timeStart).then(resp => {
                console.log("test", resp);
                this.durations = resp.durations;
                console.log("durations : ", this.durations)
            });

        },
        created() {
            console.log("items : ", this.items);
            console.log("slot : ", this.slotActivity);
            this.durationSelected = this.slotActivity.duration;
            this.inputData[1] = 1;

        },
        methods: {
            moment(date) {
                return moment(date);
            },
            updateValue(id) {

                console.log("id:", id);
                let element = document.getElementById('input-'+id);
                console.log("element:", element);
                console.log("value:", element.value);
                this.inputData[id] = element.value;
                console.log("input", this.inputData);

            },

            updateValueAttender(id, index) {
                console.log("id:", id);
                let element = document.getElementById('input-'+id+'-'+index);
                console.log("element:", element);
                console.log("value:", element.value);

                this.attenders[index][id] = element.value;
                console.log("input", this.inputData);
            },
            addAttenders (count) {
                for (let d = 0; d < count; d++) {
                    let attender = [];
                    this.items.forEach(item => {
                        attender[item.id] = null;
                    });

                    this.attenders.push(attender);
                }
            },
            removeAttender (id) {
                console.log("ID ===> ", id);
                console.log("ALL ===> ", this.attenders);
                this.attenders.forEach(function(item, index, object) {
                    if (index === id) {
                        console.log(object);
                        console.log(item);
                        object.splice(index, 1);
                    }
                });
            },
            valideForm() {

                console.log("TEST 1");
                let stringDate = moment(this.date).format('DD-MM-Y');
                let data = {
                    duration: parseInt(this.durationSelected),
                    player: this.inputData,
                    form: this.attenders,
                    price: this.priceActivity()
                };

                bookingService.addBookingActivity(data, stringDate, this.slotActivity).then(resp => {
                    if (resp.success) {
                        this.$emit("cancel");
                    }
                })
                .catch(err => {
                    console.log("ERROR : ", err);
                });
            },
            handleCanceled() {
                this.$emit("cancel");
            },
            getNbAttenders() {
                return this.attenders.length;
            },
            getTotalPlayer() {
                this.inputData[1] = this.attenders.length + 1;
                return this.attenders.length + 1;
            },
            priceActivity() {
                if (this.durationSelected != null) {
                    console.log("duration selected : ", this.durationSelected);
                    let durationSele = parseInt(this.durationSelected);
                    return ((durationSele / this.slotActivity.duration) * this.slotActivity.price ) * this.getTotalPlayer();
                }
                return this.slotActivity.price  * this.getTotalPlayer();
            }
        }
    };
</script>
<style>
</style>
